import { STACK, ApiClient } from '@/Ship';

export default function (email) {
    return STACK.push(() => ApiClient.post('/forgot-password', {
        email,
        app: process.env.VUE_APP_NAME
    }));
}
